import { writable } from 'svelte/store';

/**
 * Represents the real institution of the authenticated account.
 * @type {Writable<InstitutionLeaf?>}
 */
export const realInstitutionStore = writable(null);
